angular.module('tf.services')

    .service('FileUploadService', function (HttpService) {
        this.isUploading = false;

        this.getPresignedUrl = function(name, type, cachebusting){
            return HttpService.get("upload/presignedurl", {
                filename        : name,
                filetype        : type,
                cachebusting    : cachebusting
            })
                .then(function(res){
                    return res.data;
                });
        };

        return this;
    })
;
